import { useModals } from "@/features/modals/hooks";
import { type InstalledWidget, type WidgetSetting } from "@repo/api";
import { Button } from "@repo/skapa";
import { t } from "@repo/translation";
import { RightAlignedButtonWrapper } from "@repo/ui";

interface ClearAllSettingsButtonProps {
  isInstalled: boolean;
  widget: InstalledWidget;
  setSettings: React.Dispatch<React.SetStateAction<WidgetSetting>>;
  onUpdateWidget: (widget: InstalledWidget) => Promise<void>;
}

export const ClearAllSettingsButton = ({
  isInstalled,
  widget,
  setSettings,
  onUpdateWidget,
}: ClearAllSettingsButtonProps) => {
  const { pushModal } = useModals();

  return (
    <RightAlignedButtonWrapper>
      <Button
        text={t("action.clear_all_settings")}
        size="small"
        type="primary"
        onClick={() => {
          pushModal({
            type: "CONFIRM",
            onConfirm: () => {
              setSettings({});

              if (isInstalled) {
                onUpdateWidget({
                  ...widget,
                  widgetSettings: {
                    ...widget.widgetSettings,
                    appSetting: {},
                  },
                });
              }
            },
            title: t("action.confirm_title_widget_settings_reset"),
            message: t("prompt.confirm_message_widget_settings_reset"),
          });
        }}
      />
    </RightAlignedButtonWrapper>
  );
};
